import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SaleItemBulkUpdateExportDialogData {
  selectedExportType: number;
  update_schedule_at: string;
  update_type: number;
}

@Component({
  selector: 'app-sale-item-bulk-update-export-dialog',
  templateUrl: './sale-item-bulk-update-export-dialog.component.html',
  styleUrls: ['./sale-item-bulk-update-export-dialog.component.scss'],
  standalone: false
})
export class SaleItemBulkUpdateExportDialogComponent implements OnInit {
  selectedExportType = 2;
  update_schedule_at = '';
  update_type = 0;

  constructor(
    public dialogRef: MatDialogRef<SaleItemBulkUpdateExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaleItemBulkUpdateExportDialogData
  ) {
    if (data) {
      this.selectedExportType = data.selectedExportType;
      this.update_schedule_at = data.update_schedule_at;
      this.update_type = data.update_type;
    }
  }

  ngOnInit(): void {}

  confirmExport(): void {
    this.dialogRef.close(this.selectedExportType);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
